import { ReactNode, useEffect } from 'react';
import classNames from 'classnames';

import { useCollapsed, useSetCollapsed } from '~features/shared/collapse';
import { XIcon } from '~shared/ui/Icons';
import { useWindowInnerWidth } from '~shared/ui/utils';

import styles from './authSider.module.scss';

interface AuthSiderProps {
  children?: ReactNode;
}

export const AuthSider: React.FC<AuthSiderProps> = ({ children }) => {
  const collapsed = useCollapsed();
  const setCollapsed = useSetCollapsed();
  const windowWidth = useWindowInnerWidth();

  const bgClass = classNames(styles.bg, !collapsed ? styles.closedBg : '');
  const siderClass = classNames(styles.collapsed, !collapsed ? styles.closed : '');

  const handleCollapse = () => {
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    if (windowWidth <= 768) {
      if (collapsed) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'unset';
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collapsed]);

  return (
    <div className={bgClass} onClick={handleCollapse}>
      <div className={siderClass}>
        <div onClick={handleCollapse}>
          <div className="flex justify-end h-[80px] items-center">
            <XIcon />
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};
